import { Component, Input, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RouteService } from 'src/app/services/route.service';
import { TripService } from 'src/app/services/trip.service';
import { Trip } from 'src/app/_models/daws/trip';

@Component({
  selector: 'delete-route',
  templateUrl: './delete-route.component.html',
})
export class DeleteRouteComponent {
  @Input() route: Trip;
  loading: boolean;
  errorMessage = '';
  deleteEvent: EventEmitter<number> = new EventEmitter();
  cancelEvent = new EventEmitter();
  constructor(
    public deleteRouteModalRef: BsModalRef,
    private tripService: TripService,
    private routeService: RouteService
  ) {}

  deleteRoute() {
    this.loading = true;
    this.tripService.deleteTrip(this.route.Id).subscribe(
      (dataUpdated) => {
        if (dataUpdated.ItemsModified > 0) {
          this.deleteEvent.emit(this.route.Id);
          this.routeService.updateAfterDeleteSavedRoute(this.route.Id);
          this.loading = false;
        }
        this.deleteRouteModalRef.hide();
        this.cancelEvent.emit();
      },
      (err) => {
        this.errorMessage =
          'There was an error deleting the saved route, please try again later.';
        this.loading = false;
      }
    );
  }

  cancel() {
    this.cancelEvent.emit();
    this.deleteRouteModalRef.hide();
  }
}
